module.exports = __webpack_public_path__ + "img/product-08.e1497e4f.jpg";